import { getWindow } from '@/helpers/globals.ts'

export function trackGtmEvent(
    eventName: string,
    data: Record<string, any>
): void {
    getWindow()?.dataLayer?.push({
        event: eventName,
        ...data,
    })
}
